export interface DesktopSocketEvent {id:string;type:'open'|'message'|'close'|'error';data?:string;code?:number}
export interface DesktopOnlineBridge {
  startAuth():Promise<void>;
  signOut():Promise<void>;
  requestAPI(input:{method:string;path:string;body?:unknown}):Promise<{status:number;data:unknown}>;
  socketOpen(matchId:string):Promise<string>;
  socketSend(id:string,data:string):Promise<void>;
  socketClose(id:string):Promise<void>;
  onSocketEvent(listener:(event:DesktopSocketEvent)=>void):()=>void;
  onAuthChanged(listener:()=>void):()=>void;
}
export interface DesktopBridge {
  loadSave():Promise<unknown|null>;saveGame(data:unknown):Promise<void>;
  loadSettings():Promise<unknown|null>;saveSettings(data:unknown):Promise<void>;
  setFullscreen(enabled:boolean):Promise<void>;
  online:DesktopOnlineBridge;
}

export function desktopFetch(bridge:DesktopOnlineBridge):typeof fetch {
  return (async(input:RequestInfo|URL,init?:RequestInit)=>{
    const path=String(input),method=init?.method??'GET';
    const body=typeof init?.body==='string'?JSON.parse(init.body):undefined;
    const reply=await bridge.requestAPI({method,path,...(body===undefined?{}:{body})});
    return new Response(JSON.stringify(reply.data),{status:reply.status,headers:{'Content-Type':'application/json'}});
  }) as typeof fetch;
}

/** WebSocket-shaped adapter. The native process owns the actual authenticated socket. */
export class DesktopSocket {
  readyState=0;
  onopen:(()=>void)|null=null;
  onmessage:((event:{data:string})=>void)|null=null;
  onclose:((event:{code:number})=>void)|null=null;
  onerror:(()=>void)|null=null;
  private id:string|null=null;
  private buffered:DesktopSocketEvent[]=[];
  private unsubscribe:()=>void;
  constructor(private bridge:DesktopOnlineBridge,matchId:string){
    this.unsubscribe=bridge.onSocketEvent(event=>{if(this.id)this.receive(event);else this.buffered.push(event);});
    void bridge.socketOpen(matchId).then(id=>{
      this.id=id;if(this.readyState===3){void bridge.socketClose(id);return;}
      for(const event of this.buffered)this.receive(event);this.buffered=[];
    }).catch(()=>{this.onerror?.();this.close(1006);});
  }
  private receive(event:DesktopSocketEvent){
    if(event.id!==this.id||this.readyState===3)return;
    if(event.type==='open'){this.readyState=1;this.onopen?.();}
    else if(event.type==='message')this.onmessage?.({data:event.data??''});
    else if(event.type==='close'){this.readyState=3;this.unsubscribe();this.onclose?.({code:event.code??1006});}
    else this.onerror?.();
  }
  send(data:string){if(!this.id||this.readyState!==1)throw new Error('Online connection is not ready.');void this.bridge.socketSend(this.id,data).catch(()=>{this.onerror?.();this.close(1006);});}
  close(code=1000){if(this.readyState===3)return;this.readyState=3;this.unsubscribe();if(this.id)void this.bridge.socketClose(this.id).catch(()=>{});this.onclose?.({code});}
}
